import { useTheme } from '@mui/material';

import { MenuIconProps } from './menu-icon-props.interface';

export const SitesMenuIcon = ({ stroke, filled, ...props }: MenuIconProps) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return filled ? (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0007 2.5C18.9775 2.50089 22.9176 11.3869 17.8015 16.5039L17.8005 16.5029L13.239 21.0713C12.5983 21.7127 11.5838 21.7523 10.8962 21.1914L10.7624 21.0713L6.1999 16.5029C1.08463 11.3857 5.02373 2.50034 12.0007 2.5ZM11.9997 8.10547C10.6743 8.10561 9.60029 9.18046 9.60029 10.5059C9.6005 11.8311 10.6745 12.9051 11.9997 12.9053C13.3251 12.9053 14.3999 11.8312 14.4001 10.5059C14.4001 9.18038 13.3252 8.10547 11.9997 8.10547Z"
        fill={strokeColor}
      />
    </svg>
  ) : (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.2702 15.9733C21.8988 11.3447 18.3324 3.25 12 3.25C5.66766 3.25 2.10129 11.3447 6.72988 15.9733L11.2925 20.5416C11.6831 20.9327 12.317 20.9327 12.7076 20.5416L17.2702 15.9733Z"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
      <circle
        cx="12"
        cy="10.4498"
        r="2.4"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
    </svg>
  );
};
